export const frSupervisorOperations = {
  "Live map and messages":"Carte en direct et messages",
  "No authorized options are available. Ask an administrator to configure this location.":"Aucune option autorisée. Demandez à un administrateur de configurer ce lieu.",
  "Update status":"Mettre à jour l’état",
  "Supervisor operations": "Opérations de supervision",
  "Today’s operations": "Opérations du jour",
  "Operational tasks": "Tâches opérationnelles",
  "Site briefings": "Consignes du site",
  "Worker groups": "Groupes de travailleurs",
  "Pending timesheets": "Feuilles de temps en attente",
  "Assigned location": "Lieu attribué",
  "Supervisor sections": "Sections du superviseur",
  "Choose a location": "Choisir un lieu",
  "Choose an option": "Choisir une option",
  "Loading operations": "Chargement des opérations",
  "No authorized locations are available.": "Aucun lieu autorisé n’est disponible.",
  "Time zone": "Fuseau horaire",
  "Active and upcoming shifts": "Quarts actifs et à venir",
  "Assigned workers": "Travailleurs affectés",
  "Assigned worker": "Travailleur affecté",
  "Access or capability unavailable": "Accès ou fonctionnalité indisponible",
  "No records in this location, or this capability is unavailable.": "Aucun dossier à ce lieu, ou fonctionnalité indisponible.",
  "Filter status": "Filtrer par état",
  "Revision": "Révision",
  "Template rules": "Règles du modèle",
  "Shift rule": "Règle de quart",
  "Weekday (Sunday = 0)": "Jour de semaine (dimanche = 0)",
  "Start time": "Heure de début",
  "End time": "Heure de fin",
  "Expected staffing": "Effectif prévu",
  "Break minutes": "Pause en minutes",
  "Paid break": "Pause rémunérée",
  "Remove rule": "Retirer la règle",
  "Add rule": "Ajouter une règle",
  "Required qualifications": "Qualifications requises",
  "Apply template": "Appliquer le modèle",
  "Archive this record?": "Archiver ce dossier ?",
  "Remove this member?": "Retirer ce membre ?",
  "Publish this version?": "Publier cette version ?",
  "Confirm action": "Confirmer l’action",
  "Create revision": "Créer une révision",
  "Edit operations record": "Modifier le dossier opérationnel",
  "Record details": "Détails du dossier",
  "Required briefings": "Consignes requises",
  "Loading briefings": "Chargement des consignes",
  "No applicable briefings are available.": "Aucune consigne applicable n’est disponible.",
  "Acknowledged": "Accusé de réception",
  "Acknowledgment required": "Accusé de réception requis",
  "Read instructions": "Lire les consignes",
  "I acknowledge this version": "J’accuse réception de cette version",
  "Acknowledgment report": "Rapport des accusés de réception",
  "Download verified attachment": "Télécharger la pièce jointe vérifiée",
  "Attachment could not be verified. Ask your supervisor for the current document.": "Impossible de vérifier la pièce jointe. Demandez le document actuel à votre superviseur.",
  "Safety instructions": "Consignes de sécurité",
  "Shift instructions": "Consignes du quart",
  "Effective from": "En vigueur à partir du",
  "Effective until": "En vigueur jusqu’au",
  "Attachment name": "Nom de la pièce jointe",
  "Attachment URL": "Adresse de la pièce jointe",
  "Attachment SHA-256": "Empreinte SHA-256 de la pièce jointe",
  "Rejection reason": "Motif du refus",
  "Decision history": "Historique des décisions",
  "Recorded hours": "Heures enregistrées",
  "Payroll locked": "Paie verrouillée",
  "Payroll unlocked": "Paie non verrouillée",
  "Existing group member": "Membre actuel du groupe",
  "Add member": "Ajouter un membre",
  "Add comment": "Ajouter un commentaire",
  "Assignee": "Personne affectée",
  "Due date": "Échéance",
  "From date": "Date de début",
  "To date": "Date de fin",
  "From date (YYYY-MM-DD)": "Date de début (AAAA-MM-JJ)",
  "To date (YYYY-MM-DD)": "Date de fin (AAAA-MM-JJ)",
  "Due date (device time, YYYY-MM-DDTHH:mm)": "Échéance (heure de l’appareil, AAAA-MM-JJTHH:mm)",
  "Effective from (device time, YYYY-MM-DDTHH:mm)": "Début (heure de l’appareil, AAAA-MM-JJTHH:mm)",
  "Effective until (device time, YYYY-MM-DDTHH:mm)": "Fin (heure de l’appareil, AAAA-MM-JJTHH:mm)",
  "Dates and times use your device time zone. Template times use the template time zone.": "Les dates et heures suivent le fuseau de votre appareil. Les heures des modèles suivent leur propre fuseau.",
  "Refresh before retrying this action.": "Actualisez avant de réessayer cette action.",
  "Access or capability is unavailable. Refresh your access and choose an authorized location.": "Accès ou fonctionnalité indisponible. Actualisez vos accès et choisissez un lieu autorisé.",
  "This record changed or is locked. Refresh, review the current version, and try again.": "Ce dossier a changé ou est verrouillé. Actualisez, vérifiez la version actuelle, puis réessayez.",
  "Your session expired. Sign in again.": "Votre session a expiré. Reconnectez-vous.",
  "This record is no longer available in your location.": "Ce dossier n’est plus disponible à votre lieu.",
  "Check the required fields, dates, and selected people, then try again.": "Vérifiez les champs obligatoires, les dates et les personnes choisies, puis réessayez.",
  "The request could not be confirmed. Refresh before retrying a creation or publication.": "La demande n’a pas pu être confirmée. Actualisez avant de réessayer une création ou publication.",
  "Saving": "Enregistrement",
  "Create": "Créer",
  "Archive": "Archiver",
  "Publish": "Publier",
  "Version": "Version",
  "Comments": "Commentaires",
  "History": "Historique",
  "Instructions": "Consignes",
  "Title": "Titre",
  "Name": "Nom",
  "Project": "Projet",
  "Job": "Emploi",
  "Worker": "Travailleur",
  "Priority": "Priorité",
  "Status": "État",
  "Approve": "Approuver",
  "Reject": "Refuser",
  "Assign": "Affecter",
  "Confirm": "Confirmer",
  "Close": "Fermer",
  "Open": "Ouvrir",
  "Remove": "Retirer",
  "Edit": "Modifier",
  "Save": "Enregistrer",
  "Cancel": "Annuler",
  "Refresh": "Actualiser",
  "Comment": "Commentaire",
  "All statuses": "Tous les états",
  "Shift templates": "Modèles de quarts",
  "Notifications": "Notifications",
  "Timesheet": "Feuille de temps",
  "hours": "heures",
  "active shifts": "quarts actifs",
  "upcoming shifts": "quarts à venir",
  "expected staffing": "effectif prévu",
  "expected workforce": "travailleurs attendus",
  "no shows": "absences",
  "punched in": "présents",
  "missed punch outs": "pointages de sortie manquants",
  "long open shifts": "quarts ouverts prolongés",
  "pending timesheets": "feuilles de temps en attente",
  "open tasks": "tâches ouvertes",
  "overdue tasks": "tâches en retard",
  "required acknowledgments": "accusés requis",
  "draft": "brouillon",
  "active": "actif",
  "paused": "en pause",
  "open": "ouvert",
  "in_progress": "en cours",
  "blocked": "bloqué",
  "completed": "terminé",
  "published": "publié",
  "archived": "archivé",
  "cancelled": "annulé",
  "confirmed": "confirmé",
  "pending_worker_acceptance": "en attente d’acceptation",
  "pending_review": "en attente de révision",
  "approved_supervisor": "approuvé par le superviseur",
  "rejected": "refusé",
  "low": "faible",
  "normal": "normale",
  "high": "élevée",
  "urgent": "urgent",
  "shifts": "quarts",
  "workforce": "effectif",
  "attendance": "présence"
}
export const arSupervisorOperations = {
  "Live map and messages":"الخريطة المباشرة والرسائل",
  "No authorized options are available. Ask an administrator to configure this location.":"لا توجد خيارات مصرح بها. اطلب من المسؤول إعداد هذا الموقع.",
  "Update status":"تحديث الحالة",
  "Supervisor operations": "عمليات الإشراف",
  "Today’s operations": "عمليات اليوم",
  "Operational tasks": "المهام التشغيلية",
  "Site briefings": "تعليمات الموقع",
  "Worker groups": "مجموعات العمال",
  "Pending timesheets": "سجلات الوقت المعلقة",
  "Assigned location": "الموقع المخصص",
  "Supervisor sections": "أقسام المشرف",
  "Choose a location": "اختر موقعاً",
  "Choose an option": "اختر خياراً",
  "Loading operations": "جار تحميل العمليات",
  "No authorized locations are available.": "لا توجد مواقع مصرح بها.",
  "Time zone": "المنطقة الزمنية",
  "Active and upcoming shifts": "الورديات الحالية والقادمة",
  "Assigned workers": "العمال المعينون",
  "Assigned worker": "عامل معين",
  "Access or capability unavailable": "الوصول أو الميزة غير متاحة",
  "No records in this location, or this capability is unavailable.": "لا توجد سجلات في هذا الموقع أو الميزة غير متاحة.",
  "Filter status": "تصفية الحالة",
  "Revision": "المراجعة",
  "Template rules": "قواعد القالب",
  "Shift rule": "قاعدة الوردية",
  "Weekday (Sunday = 0)": "يوم الأسبوع (الأحد = 0)",
  "Start time": "وقت البدء",
  "End time": "وقت الانتهاء",
  "Expected staffing": "العدد المتوقع للعمال",
  "Break minutes": "دقائق الاستراحة",
  "Paid break": "استراحة مدفوعة",
  "Remove rule": "حذف القاعدة",
  "Add rule": "إضافة قاعدة",
  "Required qualifications": "المؤهلات المطلوبة",
  "Apply template": "تطبيق القالب",
  "Archive this record?": "هل تريد أرشفة هذا السجل؟",
  "Remove this member?": "هل تريد إزالة هذا العضو؟",
  "Publish this version?": "هل تريد نشر هذا الإصدار؟",
  "Confirm action": "تأكيد الإجراء",
  "Create revision": "إنشاء مراجعة",
  "Edit operations record": "تعديل السجل التشغيلي",
  "Record details": "تفاصيل السجل",
  "Required briefings": "التعليمات المطلوبة",
  "Loading briefings": "جار تحميل التعليمات",
  "No applicable briefings are available.": "لا توجد تعليمات تنطبق عليك.",
  "Acknowledged": "تم الإقرار",
  "Acknowledgment required": "الإقرار مطلوب",
  "Read instructions": "قراءة التعليمات",
  "I acknowledge this version": "أقر بقراءة هذا الإصدار",
  "Acknowledgment report": "تقرير الإقرارات",
  "Download verified attachment": "تنزيل المرفق المتحقق منه",
  "Attachment could not be verified. Ask your supervisor for the current document.": "تعذر التحقق من المرفق. اطلب الوثيقة الحالية من مشرفك.",
  "Safety instructions": "تعليمات السلامة",
  "Shift instructions": "تعليمات الوردية",
  "Effective from": "ساري من",
  "Effective until": "ساري حتى",
  "Attachment name": "اسم المرفق",
  "Attachment URL": "رابط المرفق",
  "Attachment SHA-256": "بصمة SHA-256 للمرفق",
  "Rejection reason": "سبب الرفض",
  "Decision history": "سجل القرارات",
  "Recorded hours": "الساعات المسجلة",
  "Payroll locked": "كشف الرواتب مقفل",
  "Payroll unlocked": "كشف الرواتب غير مقفل",
  "Existing group member": "عضو حالي في المجموعة",
  "Add member": "إضافة عضو",
  "Add comment": "إضافة تعليق",
  "Assignee": "الشخص المعين",
  "Due date": "تاريخ الاستحقاق",
  "From date": "تاريخ البداية",
  "To date": "تاريخ النهاية",
  "From date (YYYY-MM-DD)": "تاريخ البداية (YYYY-MM-DD)",
  "To date (YYYY-MM-DD)": "تاريخ النهاية (YYYY-MM-DD)",
  "Due date (device time, YYYY-MM-DDTHH:mm)": "الاستحقاق (وقت الجهاز، YYYY-MM-DDTHH:mm)",
  "Effective from (device time, YYYY-MM-DDTHH:mm)": "ساري من (وقت الجهاز، YYYY-MM-DDTHH:mm)",
  "Effective until (device time, YYYY-MM-DDTHH:mm)": "ساري حتى (وقت الجهاز، YYYY-MM-DDTHH:mm)",
  "Dates and times use your device time zone. Template times use the template time zone.": "التواريخ والأوقات حسب منطقة جهازك الزمنية. أوقات القوالب حسب منطقة القالب الزمنية.",
  "Refresh before retrying this action.": "حدّث البيانات قبل إعادة محاولة هذا الإجراء.",
  "Access or capability is unavailable. Refresh your access and choose an authorized location.": "الوصول أو الميزة غير متاحة. حدّث صلاحياتك واختر موقعاً مصرحاً به.",
  "This record changed or is locked. Refresh, review the current version, and try again.": "تغير هذا السجل أو تم قفله. حدّث وراجع الإصدار الحالي ثم أعد المحاولة.",
  "Your session expired. Sign in again.": "انتهت جلستك. سجّل الدخول مجدداً.",
  "This record is no longer available in your location.": "لم يعد هذا السجل متاحاً في موقعك.",
  "Check the required fields, dates, and selected people, then try again.": "تحقق من الحقول المطلوبة والتواريخ والأشخاص المختارين ثم أعد المحاولة.",
  "The request could not be confirmed. Refresh before retrying a creation or publication.": "تعذر تأكيد الطلب. حدّث البيانات قبل إعادة محاولة الإنشاء أو النشر.",
  "Saving": "جار الحفظ",
  "Create": "إنشاء",
  "Archive": "أرشفة",
  "Publish": "نشر",
  "Version": "الإصدار",
  "Comments": "التعليقات",
  "History": "السجل",
  "Instructions": "التعليمات",
  "Title": "العنوان",
  "Name": "الاسم",
  "Project": "المشروع",
  "Job": "العمل",
  "Worker": "العامل",
  "Priority": "الأولوية",
  "Status": "الحالة",
  "Approve": "موافقة",
  "Reject": "رفض",
  "Assign": "تعيين",
  "Confirm": "تأكيد",
  "Close": "إغلاق",
  "Open": "فتح",
  "Remove": "إزالة",
  "Edit": "تعديل",
  "Save": "حفظ",
  "Cancel": "إلغاء",
  "Refresh": "تحديث",
  "Comment": "تعليق",
  "All statuses": "جميع الحالات",
  "Shift templates": "قوالب الورديات",
  "Notifications": "الإشعارات",
  "Timesheet": "سجل الوقت",
  "hours": "ساعات",
  "active shifts": "الورديات النشطة",
  "upcoming shifts": "الورديات القادمة",
  "expected staffing": "العدد المتوقع للعمال",
  "expected workforce": "العمال المتوقعون",
  "no shows": "حالات الغياب",
  "punched in": "الحاضرون",
  "missed punch outs": "تسجيلات الخروج المفقودة",
  "long open shifts": "الورديات المفتوحة الطويلة",
  "pending timesheets": "سجلات الوقت المعلقة",
  "open tasks": "المهام المفتوحة",
  "overdue tasks": "المهام المتأخرة",
  "required acknowledgments": "الإقرارات المطلوبة",
  "draft": "مسودة",
  "active": "نشط",
  "paused": "متوقف مؤقتاً",
  "open": "مفتوح",
  "in_progress": "قيد التنفيذ",
  "blocked": "محظور",
  "completed": "مكتمل",
  "published": "منشور",
  "archived": "مؤرشف",
  "cancelled": "ملغى",
  "confirmed": "مؤكد",
  "pending_worker_acceptance": "بانتظار قبول العامل",
  "pending_review": "بانتظار المراجعة",
  "approved_supervisor": "وافق المشرف",
  "rejected": "مرفوض",
  "low": "منخفضة",
  "normal": "عادية",
  "high": "مرتفعة",
  "urgent": "عاجلة",
  "shifts": "الورديات",
  "workforce": "القوى العاملة",
  "attendance": "الحضور"
}

export const trSupervisorOperations = {
  "Supervisor operations": "Süpervizör işlemleri",
  "Today’s operations": "Bugünkü işlemler",
  "Operational tasks": "Operasyonel görevler",
  "Site briefings": "Saha talimatları",
  "Worker groups": "Çalışan grupları",
  "Pending timesheets": "Bekleyen puantajlar",
  "Assigned location": "Atanan konum",
  "Supervisor sections": "Süpervizör bölümleri",
  "Choose a location": "Konum seçin",
  "Choose an option": "Bir seçenek seçin",
  "Loading operations": "İşlemler yükleniyor",
  "No authorized locations are available.": "Yetkili konum bulunamadı.",
  "Time zone": "Saat dilimi",
  "Active and upcoming shifts": "Aktif ve yaklaşan vardiyalar",
  "Assigned workers": "Atanan çalışanlar",
  "Assigned worker": "Atanan çalışan",
  "Access or capability unavailable": "Erişim veya özellik kullanılamıyor",
  "No records in this location, or this capability is unavailable.": "Bu konumda kayıt yok veya özellik kullanılamıyor.",
  "Filter status": "Duruma göre filtrele",
  "Revision": "Revizyon",
  "Template rules": "Şablon kuralları",
  "Shift rule": "Vardiya kuralı",
  "Weekday (Sunday = 0)": "Haftanın günü (Pazar = 0)",
  "Start time": "Başlangıç saati",
  "End time": "Bitiş saati",
  "Expected staffing": "Beklenen personel sayısı",
  "Break minutes": "Mola süresi (dakika)",
  "Paid break": "Ücretli mola",
  "Remove rule": "Kuralı kaldır",
  "Add rule": "Kural ekle",
  "Required qualifications": "Gerekli nitelikler",
  "Apply template": "Şablonu uygula",
  "Archive this record?": "Bu kayıt arşivlensin mi?",
  "Remove this member?": "Bu üye kaldırılsın mı?",
  "Publish this version?": "Bu sürüm yayımlansın mı?",
  "Confirm action": "İşlemi onayla",
  "Create revision": "Revizyon oluştur",
  "Edit operations record": "İşlem kaydını düzenle",
  "Record details": "Kayıt ayrıntıları",
  "Required briefings": "Gerekli talimatlar",
  "Loading briefings": "Talimatlar yükleniyor",
  "No applicable briefings are available.": "Geçerli talimat bulunamadı.",
  "Acknowledged": "Okunduğu onaylandı",
  "Acknowledgment required": "Okunduğunun onaylanması gerekiyor",
  "Read instructions": "Talimatları oku",
  "I acknowledge this version": "Bu sürümü okuduğumu onaylıyorum",
  "Acknowledgment report": "Okuma onayı raporu",
  "Download verified attachment": "Doğrulanmış eki indir",
  "Attachment could not be verified. Ask your supervisor for the current document.": "Ek doğrulanamadı. Güncel belgeyi süpervizörünüzden isteyin.",
  "Safety instructions": "Güvenlik talimatları",
  "Shift instructions": "Vardiya talimatları",
  "Effective from": "Geçerlilik başlangıcı",
  "Effective until": "Geçerlilik sonu",
  "Attachment name": "Ek adı",
  "Attachment URL": "Ek URL adresi",
  "Attachment SHA-256": "Ek SHA-256 özeti",
  "Rejection reason": "Ret nedeni",
  "Decision history": "Karar geçmişi",
  "Recorded hours": "Kaydedilen saatler",
  "Payroll locked": "Bordro kilitli",
  "Payroll unlocked": "Bordro kilidi açık",
  "Existing group member": "Mevcut grup üyesi",
  "Add member": "Üye ekle",
  "Add comment": "Yorum ekle",
  "Assignee": "Atanan kişi",
  "Due date": "Son tarih",
  "From date": "Başlangıç tarihi",
  "To date": "Bitiş tarihi",
  "From date (YYYY-MM-DD)": "Başlangıç tarihi (YYYY-MM-DD)",
  "To date (YYYY-MM-DD)": "Bitiş tarihi (YYYY-MM-DD)",
  "Due date (device time, YYYY-MM-DDTHH:mm)": "Son tarih (cihaz saati, YYYY-MM-DDTHH:mm)",
  "Effective from (device time, YYYY-MM-DDTHH:mm)": "Geçerlilik başlangıcı (cihaz saati, YYYY-MM-DDTHH:mm)",
  "Effective until (device time, YYYY-MM-DDTHH:mm)": "Geçerlilik sonu (cihaz saati, YYYY-MM-DDTHH:mm)",
  "Dates and times use your device time zone. Template times use the template time zone.": "Tarihler ve saatler cihazınızın saat dilimini kullanır. Şablon saatleri şablonun saat dilimini kullanır.",
  "Refresh before retrying this action.": "Bu işlemi yeniden denemeden önce yenileyin.",
  "Access or capability is unavailable. Refresh your access and choose an authorized location.": "Erişim veya özellik kullanılamıyor. Erişiminizi yenileyin ve yetkili bir konum seçin.",
  "This record changed or is locked. Refresh, review the current version, and try again.": "Bu kayıt değişti veya kilitli. Yenileyin, güncel sürümü inceleyin ve tekrar deneyin.",
  "Your session expired. Sign in again.": "Oturumunuzun süresi doldu. Tekrar giriş yapın.",
  "This record is no longer available in your location.": "Bu kayıt artık konumunuzda kullanılamıyor.",
  "Check the required fields, dates, and selected people, then try again.": "Gerekli alanları, tarihleri ve seçilen kişileri kontrol edip tekrar deneyin.",
  "The request could not be confirmed. Refresh before retrying a creation or publication.": "İstek doğrulanamadı. Oluşturmayı veya yayımlamayı yeniden denemeden önce yenileyin.",
  "Saving": "Kaydediliyor",
  "Create": "Oluştur",
  "Archive": "Arşivle",
  "Publish": "Yayımla",
  "Version": "Sürüm",
  "Comments": "Yorumlar",
  "History": "Geçmiş",
  "Instructions": "Talimatlar",
  "Title": "Başlık",
  "Name": "Ad",
  "Project": "Proje",
  "Job": "İş",
  "Worker": "Çalışan",
  "Priority": "Öncelik",
  "Status": "Durum",
  "Approve": "Onayla",
  "Reject": "Reddet",
  "Assign": "Ata",
  "Confirm": "Onayla",
  "Close": "Kapat",
  "Open": "Aç",
  "Remove": "Kaldır",
  "Edit": "Düzenle",
  "Save": "Kaydet",
  "Cancel": "İptal",
  "Refresh": "Yenile",
  "Comment": "Yorum",
  "All statuses": "Tüm durumlar",
  "Shift templates": "Vardiya şablonları",
  "Notifications": "Bildirimler",
  "Timesheet": "Puantaj",
  "hours": "saat",
  "active shifts": "aktif vardiyalar",
  "upcoming shifts": "yaklaşan vardiyalar",
  "expected staffing": "beklenen personel sayısı",
  "expected workforce": "beklenen çalışanlar",
  "no shows": "gelmeyenler",
  "punched in": "giriş yapanlar",
  "missed punch outs": "eksik çıkış kayıtları",
  "long open shifts": "uzun süredir açık vardiyalar",
  "pending timesheets": "bekleyen puantajlar",
  "open tasks": "açık görevler",
  "overdue tasks": "gecikmiş görevler",
  "required acknowledgments": "gerekli okuma onayları",
  "draft": "taslak",
  "active": "aktif",
  "paused": "duraklatıldı",
  "open": "açık",
  "in_progress": "devam ediyor",
  "blocked": "engellendi",
  "completed": "tamamlandı",
  "published": "yayımlandı",
  "archived": "arşivlendi",
  "cancelled": "iptal edildi",
  "confirmed": "onaylandı",
  "pending_worker_acceptance": "çalışan onayı bekleniyor",
  "pending_review": "inceleme bekleniyor",
  "approved_supervisor": "süpervizör onayladı",
  "rejected": "reddedildi",
  "low": "düşük",
  "normal": "normal",
  "high": "yüksek",
  "urgent": "acil",
  "shifts": "vardiyalar",
  "workforce": "iş gücü",
  "attendance": "devam durumu",
  "Live map and messages": "Canlı harita ve mesajlar",
  "Update status": "Durumu güncelle",
  "No authorized options are available. Ask an administrator to configure this location.": "Yetkili seçenek bulunamadı. Yöneticiden bu konumu yapılandırmasını isteyin."
}
